import { render } from "./odn-badges.vue?vue&type=template&id=47379d28"
const script = {}

import "./odn-badges.vue?vue&type=style&index=0&id=47379d28&lang=scss"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__